import React from "react";
import { KanbanManager } from "../states/KanbanManager";

export const KanbanContext = React.createContext<KanbanManager>(undefined);
export const KanbanContextProvider = KanbanContext.Provider;
